<!-- Mobile navbar -->
<nav
    class="categories-dropdown navbar navbar-expand-lg navbar-dark nav-category nav-category--mobile animated fadeIn px-3">
    @if (isShowingSearchMobile()) {
    <div class="category-search--mobile">
        <app-search-bar></app-search-bar>
    </div>
    } @else {
    <div class="d-flex flex-row w-100 gap-3 animated fadeInUp">
        <!-- Category -->
        <mat-form-field class="w-100 my-2">
            <mat-label>Category</mat-label>
            <mat-select #matSelect [disabled]="isContentLoading()" [value]="selectedCategory()?.id || null">
                @if (sidebar().length) {
                @for (item of sidebar(); track $index) {
                <mat-option [value]="item.id" (click)="triggerCategoryInfoFetch(item)">{{ item.name
                    }}</mat-option>
                }
                }
            </mat-select>
        </mat-form-field>
        <!-- Subcategory -->
        <mat-form-field class="w-100 my-2">
            <mat-label>Subcategory</mat-label>
            <mat-select #matSelect [disabled]="isContentLoading()" [value]="subcategorySelected">
                @if (selectedCategory()?.sublist?.length) {
                @for (item of selectedCategory().sublist; track $index) {
                <mat-option [value]="item.id" (click)="goToSection(item)">{{ item.name }}</mat-option>
                }
                }
            </mat-select>
        </mat-form-field>
    </div>
    }
</nav>